var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocketLaunch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7873 20.0594C20.9264 20.6503 21 21.2665 21 21.8999C21 26.3182 17.4183 29.8999 13 29.8999V23.5003M20.7873 20.0594C25.7659 16.4214 29 10.5382 29 3.8999C22.362 3.90018 16.4793 7.13438 12.8416 12.1129M20.7873 20.0594C18.5092 21.724 15.8658 22.9186 13 23.5003M12.8416 12.1129C12.2504 11.9736 11.6338 11.8999 11 11.8999C6.58172 11.8999 3 15.4816 3 19.8999H9.40097M12.8416 12.1129C11.1771 14.3909 9.98268 17.0342 9.40097 19.8999M13 23.5003C12.8621 23.5283 12.7237 23.5549 12.5848 23.58C11.3756 22.6212 10.2799 21.5255 9.32106 20.3163C9.34626 20.177 9.3729 20.0382 9.40097 19.8999M6.41588 23.0876C4.94951 24.1815 4 25.9298 4 27.8999C4 28.2157 4.0244 28.5258 4.07142 28.8285C4.37406 28.8755 4.68418 28.8999 5 28.8999C6.9701 28.8999 8.71843 27.9504 9.81233 26.484M22 12.8999C22 14.0045 21.1046 14.8999 20 14.8999C18.8954 14.8999 18 14.0045 18 12.8999C18 11.7953 18.8954 10.8999 20 10.8999C21.1046 10.8999 22 11.7953 22 12.8999Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketLaunch);
export default __webpack_public_path__ + "static/media/rocket-launch.22ae6f3e062edd21d06d0c0d13dd9d12.svg";
export { ForwardRef as ReactComponent };